import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  Row,
  Table,
  Badge,
  ListGroup,
  Modal,
} from 'react-bootstrap';
import { PlusLg } from 'react-bootstrap-icons';
import { makeUID } from '../../helpers';
import FileDownloadOrLinkCard from '../common/FileDownloadOrLinkCard';
// import FileDownloadOrLinkCard from "../common/FileDownloadOrLinkCard"
import { floatRenderer } from '../../services/formatSvc';
import { FloatFlexibleInput } from '../common/MonetaryFloatInput';
import Required from '../Required';
import './styling.less';
import UniqueResultDocument from './UniqueResultDocument';

export default function UniqueResultCard({
  data,
  onResultChange,
  requestFileRemove,
  canEdit,
}) {
  const handleData = (data) => {
    const res = [];
    data?.values?.forEach((value) => {
      res.push(...(value.files || []));
    });
    return res;
  };

  const handleFileAdd = () => {
    const newFile = {
      id: null,
      title: undefined,
      type: 'link',
      hash: makeUID(5),
    };
    onResultChange(data.id, 'files', [...data.files, newFile]);
  };

  const handleFileRemove = async (id, hash) => {
    if (id) {
      await requestFileRemove(data.id, id);
    }
    const updatedFiles = data.files.filter((f) => f.hash !== hash);
    onResultChange(data.id, 'files', updatedFiles);
  };

  const [show, setShow] = useState(false);
  return (
    <div>
      <div
        style={{ color: '#0D6EFD', cursor: 'pointer' }}
        onClick={() => setShow(true)}
      >
        <svg
          width="16"
          height="20"
          viewBox="0 0 16 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 0C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.895431 20 2 20H14C15.1046 20 16 19.1046 16 18V6L13.5 3L11 0H2ZM12 14H4V16H12V14ZM4 10H12V12H4V10ZM10 1V7H15L10 1Z"
            fill="#305FFD"
          />
        </svg>
        {'  '}
        <span style={{ paddingRight: '14px' }}>
          {handleData(data).filter((e) => e.link == null).length}
        </span>
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.9344 7.22234L1.99662 9.16012C0.341633 10.8151 0.341633 13.4984 1.99662 15.1534C3.65161 16.8083 6.33488 16.8083 7.98986 15.1534L10.5727 12.5705C12.2277 10.9155 12.2277 8.23223 10.5727 6.57724C10.2225 6.227 9.8262 5.95088 9.40335 5.74888L8.57499 6.57725C8.48885 6.66338 8.41616 6.75788 8.35692 6.85812C8.80251 6.9858 9.22288 7.22513 9.57386 7.57612C10.6772 8.67944 10.6772 10.4683 9.57386 11.5716L6.99099 14.1545C5.88766 15.2578 4.09882 15.2578 2.99549 14.1545C1.89217 13.0512 1.89217 11.2623 2.99549 10.159L4.11515 9.03934C3.95666 8.44587 3.89641 7.83161 3.9344 7.22234Z"
            fill="#0D6EFD"
          />
          <path
            d="M5.34253 7.81196L5.57837 7.57612C5.94225 7.21224 6.38068 6.96837 6.8445 6.84451C6.96837 6.38069 7.21224 5.94225 7.57611 5.57837L7.81196 5.34253C7.10867 5.30357 6.39753 5.43902 5.74888 5.74888C5.43902 6.39753 5.30357 7.10867 5.34253 7.81196Z"
            fill="#0D6EFD"
          />
          <path
            d="M6.57724 4.5795C4.92225 6.23448 4.92225 8.91775 6.57724 10.5727C6.92748 10.923 7.32378 11.1991 7.74663 11.4011L8.84225 10.3055C8.37843 10.1816 7.93999 9.93774 7.57612 9.57386C6.47279 8.47054 6.47279 6.6817 7.57611 5.57837L10.159 2.9955C11.2623 1.89217 13.0512 1.89217 14.1545 2.99549C15.2578 4.09882 15.2578 5.88766 14.1545 6.99099L13.0348 8.11064C13.1933 8.70412 13.2536 9.31837 13.2156 9.92764L15.1534 7.98986C16.8083 6.33488 16.8083 3.65161 15.1534 1.99662C13.4984 0.341633 10.8151 0.341634 9.16012 1.99662L6.57724 4.5795Z"
            fill="#0D6EFD"
          />
          <path
            d="M11.4011 11.4011C11.711 10.7525 11.8464 10.0413 11.8075 9.33802L11.5716 9.57386C11.2077 9.93774 10.7693 10.1816 10.3055 10.3055C10.1816 10.7693 9.93774 11.2077 9.57386 11.5716L9.33802 11.8075C10.0413 11.8464 10.7525 11.711 11.4011 11.4011Z"
            fill="#0D6EFD"
          />
        </svg>
        {'  '}
        {handleData(data).filter((e) => !(e.link == null)).length}
      </div>
      <Modal size="lg" show={show} onHide={() => setShow(false)}>
        <Modal.Header>
          <Modal.Title>Подтверждающие документы</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            <div>
              <div
                style={{
                  fontSize: '18px',
                  color: '#424242',
                  fontWeight: '600',
                  marginBottom: '10px',
                }}
              >
                Файлы
              </div>
              {handleData(data).filter((e) => e.link == null).length == 0 && (
                <div>-</div>
              )}
              <ListGroup>
                {handleData(data)
                  .filter((e) => e.link == null) // e.type == "file"
                  .map((f) => (
                    <>
                      {/* <div>{f.title}</div> */}
                      <div
                        key={f.hash}
                        style={{
                          textDecoration: 'underline',
                          color: '#000070',
                        }}
                        action={!f.fileId}
                        target="_blank"
                        href={f.link}
                      >
                        <FileDownloadOrLinkCard
                          url={`/files/download/${f.fileId}`}
                          type="file"
                          link={f.link}
                          title={f.title}
                          contentType={f.contentType}
                          filename={f.fileName}
                        >
                          {f.fileName}
                        </FileDownloadOrLinkCard>
                      </div>
                    </>
                  ))}
              </ListGroup>
            </div>
          }
          <div>
            <div
              style={{
                fontSize: '18px',
                color: '#424242',
                fontWeight: '600',
                marginBottom: '10px',
              }}
            >
              Ссылки
            </div>
            {handleData(data).filter((e) => !(e.link == null)).length
                == 0 && <div>-</div>}
            {handleData(data)
              .filter((e) => !(e.link == null))
              .map((f) => (
                <div className="mb-4">
                  <div className="mb-2">{f.title}</div>
                  <a
                    key={f.hash}
                    style={{
                      textDecoration: 'underline',
                      color: '#0D6EFD',
                      overflowWrap: 'anywhere',
                    }}
                    action={!f.fileId}
                    target="_blank"
                    href={f.link}
                    rel="noreferrer"
                  >
                    {f.link}
                  </a>
                </div>
              ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={() => setShow(false)}>
            Ок
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );

  // return (
  //   <Card className="mb-4">
  //     <Card.Body className="p-4">
  //       <Row className="mb-4">
  //         <Col md={6}>
  //           <Card.Subtitle className="mb-2 text-muted">Название (план)</Card.Subtitle>
  //           <Card.Text>{data.title}</Card.Text>
  //         </Col>
  //         <Col md={6}>
  //           <Card.Subtitle className="mb-2 text-muted">Ключевой</Card.Subtitle>
  //           <Card.Text>{data.isKey ? 'Да' : 'Нет'}</Card.Text>
  //         </Col>
  //       </Row>
  //       <Row className="mb-4">
  //         <Card.Subtitle className="mb-2 text-muted">Описание фактически достигнутого результата</Card.Subtitle>
  //         <Card.Text style={{whiteSpace: 'pre-wrap'}}>{data.descr}</Card.Text>
  //       </Row>
  //       <Row className="mb-4">
  //         <Table className='read-view' >
  //           <thead>
  //             <tr>
  //               <th>Значение (план)</th>
  //               <th>Значение (факт)</th>
  //               <th>Единицы измерения</th>
  //               <th>% выполнения</th>
  //             </tr>
  //           </thead>
  //           <tbody>
  //             <tr>
  //               <td>{data.value}</td>
  //               <td>{data.fact}</td>
  //               <td>{data.unit}</td>
  //               <td>{getComplete()}</td>
  //             </tr>
  //           </tbody>
  //         </Table>
  //       </Row>
  //       <Row>
  //         <Card.Subtitle className="mb-2 text-muted">Подтверждающие документы</Card.Subtitle>
  //         <Card.Text>
  //           <ListGroup>
  //             {data.files.map(f => (
  //               <ListGroup.Item key={f.hash} style={{textDecoration: 'underline', color: '#000070'}} action={!f.fileId} target="_blank" href={f.link}>
  //                 {
  //                   f.fileId
  //                     ? <DownloadLink url={`/files/download/${f.fileId}`} filename={f.fileName}>{f.title}</DownloadLink>
  //                     : f.title
  //                 }
  //               </ListGroup.Item>
  //             ))}
  //           </ListGroup>

  //         </Card.Text>
  //       </Row>

  //     </Card.Body>
  //   </Card>
  // )
}

const cardHeaderColor = '#E3EFFF';
